module.exports = __webpack_public_path__ + "src/assets/games/15/58.jpg";